export const ruleTemplatesPath = () => '/settings/rule-templates';
